import api, { API } from "@/lib/api";

export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const res = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return `${API}/files/${res.data.path}`;
}

export async function downloadFile(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
